import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonAlpha, StackBlock, TextAlpha, TextField } from '@yonderland/andes-react';
import { ArrowRightIcon } from '@yonderland/andes-icons';
import { useAemConfig } from '@as-react/common-components';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { basketMutations } from '@as-react/common-queries';
import { useMutation } from '@tanstack/react-query';
import { DELAY } from '../../../constants/GeneralConstants';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import FormValidationUtil from '../../../util/FormValidationUtil';
import { FormField } from '../../form/FormField';
import { useSelector } from 'react-redux';
import { makeGetBasketStatusState } from '../../../redux/basket/selectors/BasketSelector';
import { useEffect, useState } from 'react';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
import { PERSONAL_SHOPPING_ADVICE_STORAGE_KEY } from '../../../constants/StorageKeysConstants';
import { BasketStatus } from '@as-react/common-types';
import { getHomepageUrl } from '@as-react/common-utils';
export const BasketOverviewPersonalShoppingAdvice = () => {
    const { t } = useTranslation([I18N_NAMESPACES.checkout, I18N_NAMESPACES.form]);
    const basketStatus = useSelector(makeGetBasketStatusState());
    const [personalShoppingAdvice, setPersonalShoppingAdvice] = useState();
    const isPersonalShoppingAdviceEnabled = () => !!personalShoppingAdvice && personalShoppingAdvice === 'true';
    const { defaultRequestParams, servicesEndpoint, root, isShopLanding } = useAemConfig();
    const { sendPersonalShoppingAdviceMail } = basketMutations({ servicesEndpoint, defaultRequestParams });
    const { mutate: sendPersonalShoppingAdviceMailMutation, isPending, isSuccess, } = useMutation(sendPersonalShoppingAdviceMail);
    const validationSchema = Yup.object({
        email: Yup.string()
            .required(t(`${I18N_NAMESPACES.account}:delivery.required`))
            .matches(FormValidationUtil.emailPatternRegex, t(`${I18N_NAMESPACES.general}:email.error.invalid`)),
    });
    const formProps = useForm({
        defaultValues: { email: '' },
        mode: 'onTouched',
        shouldFocusError: true,
        resolver: yupResolver(validationSchema),
    });
    useEffect(() => {
        if (isShopLanding) {
            const value = LocalStorageUtil.getJsonItem(PERSONAL_SHOPPING_ADVICE_STORAGE_KEY);
            if (value) {
                setPersonalShoppingAdvice(value);
            }
        }
    }, []);
    const handleSubmit = ({ email }) => {
        sendPersonalShoppingAdviceMailMutation(email, {
            onSuccess: () => setTimeout(() => (window.location.href = getHomepageUrl(root)), DELAY.DELAY_3000),
            onError: error => {
                var _a;
                const { response } = error;
                formProps.setError('email', { message: (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message });
            },
        });
    };
    if (!isShopLanding || !isPersonalShoppingAdviceEnabled() || basketStatus !== BasketStatus.READY) {
        return null;
    }
    return (_jsx(FormProvider, Object.assign({}, formProps, { children: _jsx("form", { onSubmit: formProps.handleSubmit(handleSubmit), noValidate: true, name: "personal-shopping-advice-form", children: _jsxs(StackBlock, { gap: "4", children: [_jsx(TextAlpha, { variant: "titleM", children: t(`${I18N_NAMESPACES.checkout}:checkout.basket.psa.title`) }), _jsx(FormField, { name: "email", children: (_a) => {
                            var _b = _a.fieldProps, { ref } = _b, options = __rest(_b, ["ref"]), { error } = _a;
                            return (_jsx(TextField, Object.assign({}, options, { label: t(`${I18N_NAMESPACES.checkout}:checkout.email_recognition.email.label`), name: "email", id: "email", autoComplete: "email", type: "email", error: error })));
                        } }), _jsx(ButtonAlpha, { type: "submit", theme: "branded", variant: "secondary", state: isPending || isSuccess ? 'loading' : 'interactive', text: t(`${I18N_NAMESPACES.form}:form.send`), iconRight: { size: 'sm', source: ArrowRightIcon }, fullWidth: true })] }) }) })));
};
